import { useAppSelector } from 'store/hooks';
import { sessionSelectors } from 'store/state/selectors';
import { useFeatureFlagStore } from 'zustand/featureFlag/useFeatureFlagStore';

export function useLkpGfpEmailFeatureFlag() {
  const userEmail = useAppSelector(sessionSelectors.getEmail);
  const { isLkpGfpEnabledForEmail, isLoading, isError } = useFeatureFlagStore();

  return {
    isLkpGfpEnabledForEmail: userEmail ? isLkpGfpEnabledForEmail(userEmail) : false,
    isLoading,
    isError,
    userEmail,
  };
}
